import { registerPlugin, Capacitor } from '@capacitor/core';

export interface RootStatus {
  rooted: boolean;
  confidence: number; // 0 = clean | 1-2 = low risk | 3+ = high risk
  reasons: string[];  // e.g. ["su_binary", "test_keys"]
}

interface RootDetectionPlugin {
  getRootStatus(): Promise<RootStatus>;
}

const RootDetection = registerPlugin<RootDetectionPlugin>('RootDetection');

/**
 * Returns root status from the native Android plugin.
 * On non-native platforms (web/browser) returns a safe default — root
 * detection is not applicable outside of Android.
 */
export const getRootStatus = async (): Promise<RootStatus> => {
  if (!Capacitor.isNativePlatform()) {
    return { rooted: false, confidence: 0, reasons: [] };
  }
  return RootDetection.getRootStatus();
};
